'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withGetMessages = function withGetMessages(messages, prefix) {
  return (0, _compose2.default)(_reactIntl.injectIntl, (0, _withPropsOnChange2.default)(['intl'], function (_ref) {
    var formatMessage = _ref.intl.formatMessage;
    return {
      getMessages: function getMessages(id, value) {
        return formatMessage(messages[prefix ? prefix + '.' + id : id], value);
      }
    };
  }));
};

exports.default = withGetMessages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../react-intl-inject-hoc/lib/withGetMessages.js
// module id = 321
// module chunks = 4